import React, { useMemo } from "react";
import { BarChart, MoreHorizontal, TrendingUp, TrendingDown } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./LeaderboardWidget.css";
import { getGenderAvatarUrl, getLeaderboardEntryGender } from "../../../utils/avatar";

const LeaderboardWidget = ({ leaderboard = [], currentUserId }) => {
  const navigate = useNavigate();

  const currentUserRank = useMemo(() => {
    if (!currentUserId) return null;
    return leaderboard.find((entry) => String(entry.studentId) === String(currentUserId)) || null;
  }, [leaderboard, currentUserId]);

  const topThree = leaderboard.slice(0, 3);

  return (
    <div className="widget-container">
      <div className="widget-header-row">
        <h3 className="widget-title">
          <BarChart size={20} className="widget-icon" />
          Leaderboard
        </h3>
        <button className="more-btn">
          <MoreHorizontal size={20} className="text-muted" />
        </button>
      </div>

      {!leaderboard.length ? (
        <div className="alert alert-light border">No leaderboard data yet.</div>
      ) : (
        <div className="leaderboard-card">
          <div className="user-rank-section">
            <div className="rank-left">
              <span className="rank-hash">#{currentUserRank?.rank || "-"}</span>
              <div className="rank-info">
                <span className="rank-label">Your Rank</span>
                <span className="rank-percentile">{currentUserRank ? "Track member" : "Not ranked"}</span>
              </div>
            </div>
            <div className="rank-right">
              <span className="rank-score">{currentUserRank?.points ?? 0}</span>
              <span className="rank-points-label">POINTS</span>
            </div>
          </div>

          <div className="top-list">
            {topThree.map((item, index) => (
              <div key={item.studentId} className="top-item">
                <span className="top-number">{String(index + 1).padStart(2, "0")}</span>
                <div className="top-avatar">
                  <img src={getGenderAvatarUrl(getLeaderboardEntryGender(item))} alt={item.fullName} />
                </div>
                <div className="top-member-info">
                  <span className="top-name fw-bold">{item.fullName}</span>
                  {index === 0 ? (
                    <span className="top-trend trend-up">
                      <TrendingUp size={12} className="me-1" /> Top
                    </span>
                  ) : (
                    <span className="top-trend trend-down">
                      <TrendingDown size={12} className="me-1" /> Rank {item.rank}
                    </span>
                  )}
                </div>
                <span className="top-score fw-bold">{item.points}</span>
              </div>
            ))}
          </div>

          <div className="leaderboard-footer">
            <button
              type="button"
              className="view-full-link"
              onClick={() => navigate("/leaderboard")}
            >
              View Full Leaderboard
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LeaderboardWidget;
